import { AcceptInvitationPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/accept-invitation')({
  component: AcceptInvitationPage
});
